"use client";

import { useState } from "react";
import arrowDownIcon from "@/assets/images/kbv-icon-arrow-down.svg";

export default function BetOKMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name } = league || {};

  return (
    <div className="overflow-hidden transition-[max-height] duration-300 ease-in-out bg-[var(--theme-bg)] md:rounded-t-lg rounded-t-none md:rounded-b-lg rounded-b-none">
      <div
        className="bg-table-header-gradient flex items-center justify-between cursor-pointer border-b border-transparent p-2 md:p-4 rounded-b-none md:rounded-t-lg rounded-t-none transition-[border-radius] duration-300 ease-in-out md:py-2 md:px-2"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className="flex-1">
          <div className="rounded-t-lg w-full flex items-center md:gap-x-[20px] gap-x-1">
            <p className="md:min-w-[44%] md:w-[44%] w-[80%] my-0 max-w-[271px] md:max-w-none truncate capitalize text-white md:text-md font-semi-bold text-sm">
              {name}
            </p>
            <div className="hidden md:flex flex-1 flex-row min-w-0 md:gap-x-[5px]">
              <div className="md:w-6 shrink-0" aria-hidden="true" />
              <p className="flex-1 min-w-0 flex justify-center items-center text-white font-bold my-0">Kèo chấp</p>
              <p className="flex-1 min-w-0 flex justify-center items-center text-white font-bold my-0">Tài/xỉu</p>
              <p className="flex-1 min-w-0 flex justify-center items-center text-white font-bold my-0">1X2</p>
            </div>
          </div>
        </div>
        <img src={arrowDownIcon} alt="" className={`w-5 h-5 -ml-5 transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} />
      </div>

      {/* Matches List */}
      <div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${isExpanded ? "max-h-[9999px]" : "max-h-0"}`}>
        {matches.map((match, idx) => render(match, idx))}
      </div>
    </div>
  );
}
